// extracted by mini-css-extract-plugin
export default {"switches":"switches_switches__ZIlSc","switches_items":"switches_switches_items__JrwX9"};